export const Logo = ({ className = "", dark = false }) => {
    // dark=true => used on light surfaces (kept for compatibility)
    const bg = dark ? "#FDFBF7" : "#C5A059";
    const fg = "#070A13";
    return (
        <svg
            viewBox="0 0 100 100"
            className={className}
            role="img"
            aria-label="The Raw Math"
        >
            <circle cx="50" cy="50" r="50" fill={bg} />
            <rect x="27" y="38" width="46" height="9" rx="4.5" fill={fg} />
            <rect x="27" y="53" width="46" height="9" rx="4.5" fill={fg} />
        </svg>
    );
};
